import React from 'react';

import { Link, Redirect } from 'react-router-dom';
import * as RT from '../../../constants/Routing';
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'
export default class Component extends React.Component {
  // submitTwitterToken = () => {
  //   const token = document.getElementById('twitterCallbackToken').value

  //   let params = {}
  //   token.substr(1).split('&').forEach((queryParams) => {
  //     const pair = queryParams.split('=');
  //     if (pair.length > 1) {
  //       params[pair[0]] = pair[1];
  //     } else {
  //       params['oauth_token'] = pair[0]
  //     }
  //   });

  //   this.props.twitterSignInToServer(params)
  // }

  submitGoogle = () => {
    const params = document.getElementById('googleCallbackToken').value
    // console.log('グーグルアップ', params)
    this.props.googleSignInToServer(params)
  }

  render = () => {
    if (this.props.App.signInCheckResult) {
      return (<Redirect to={RT.ROOT_PATH} />)
    } 

    const metaInfo = (
      <Helmet>
        <title>サインアップ | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)サインアップページです。ログインするためにはfacebook,twitter,gmailのアカウントが必要です。' />
      </Helmet>
    )


    return (
      <div className='new-session container'>
        <h2 className='headline'>Circrewに登録</h2>
        <div className='site-logo'>
        </div>
        {metaInfo}
        {/* <button onClick={this.props.facebookSignIn} className='btn btn-facebook btn-block mb-2'>Facebookアカウントで登録</button> */}
        <a className='btn btn-facebook btn-block mb-2' href={SG.FACEBOOK_AUTH_URL} >Facebookアカウントで登録</a>
        {/* <button onClick={this.props.twitterSignIn} className='btn btn-twitter btn-block mb-2'>Twitterアカウントで登録</button> */}
        <a href={SG.TWITTER_AUTH_URL} className='btn btn-twitter btn-block mb-2'>Twitterアカウントで登録</a>
        {/* <button onClick={() => this.props.googleSignIn(this.props.history)} className='btn btn-google btn-block'>Googleアカウントで登録</button> */}
        <a href={SG.GOOGLE_AUTH_URL} className='btn btn-google btn-block'>Googleアカウントで登録</a>
        <Link to={RT.SIGN_IN_PATH} className='btn btn-default'>ログインはこちらから</Link>
        <input type='text' className='d-none' id='twitterCallbackToken' />
        <span id='twitterTokenSubmit' onClick={this.submitTwitterToken} className='d-none'></span>
        <input type='text' id='googleCallbackToken' className='d-none' />
        <span id='googleTokenSubmit' onClick={this.submitGoogle} className='d-none'></span>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/SignUp/SignUp.jsx